export default "__VITE_ASSET__DkoLYZ33__"